import SavedReceiverItem from "./SavedReceiverItem"

const SavedReceiversList = ({receivers}) => {
  const receiversLocal = [...receivers]
  receiversLocal.sort((a, b) => b.id - a.id)
  return (
    <div className="flex flex-col items-center gap-4">
        {
            receiversLocal?.map(receiver => (
                <SavedReceiverItem key={receiver.id} receiver={receiver}/>
            ))
        }
    </div>
  )
}

export default SavedReceiversList